module.exports = __webpack_public_path__ + "static/media/Y1_NORM.44a22727.png";